// 异常分析设置配置
export const exAnalSetting = {
    "ex":{
        name:"ex",
        id: 1,
        // 分析方法 method
        type: 1,
        // 日期类型  way
        dateType:'',
        // 值
        timeValue: '',
        timeType: 'year',
        sWay: [
            {
                value: 0,
                label: $t('integration.statistics')
            },
            {
                value: 1,
                label: $t('integration.year_on_year')
            },
            {
                value: 2,
                label: $t('integration.month_on_month')
            }
        ]
    }
}

export const alarmAnalSetting={
    alarm:{
        name:"alarm",
        id: 1,
        // 分析方法 method
        type: 1,
        // 日期类型  way
        dateType:'',
        // 值
        timeValue: '',
        contrast:true,
        timeType: 'year',
        sWay: [
            {
                value: 0,
                label: $t('integration.statistics')
            },
            {
                value: 1,
                label: $t('integration.year_on_year')
            },
            {
                value: 2,
                label: $t('integration.month_on_month')
            }
        ]
    }
}
export const proportionAnalSetting ={
    normalAbnormal:{
        name:"normalAbnormal",
        id: 3,
        headerText: $t('integration.normal_and_abnormal_proportion_analysis'),
        type: 3,
        timeValue: '',
        timeType: 'daterange',
        sWay: [
            {
                value:3,
                label:$t('integration.proportion')
            }
        ],
    },
}